export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5119.7063c605.jpg";